/* eslint-disable  */
import { GenericResponseProp } from '@Src/apiServices/ApiProps/ServicesProps';
import {
  checkUniquePanAPI,
  getCompanyDetailsFromGstAPI,
  getFileUploadedDocumentStatusAPI,
  getServiceActivationDataAPI,
  getUserDocsAPI,
  getVanDetailsAPI,
  updateCompanyDetailsAPI,
} from '@Src/apiServices/onboardingService';
import {
  isValidGst,
  isValidGSTForPAN,
  isValidUdyamNumber,
} from '@Src/commons/Utils/RegexCheck';
import ApiServices from '@Src/apiServices';
import { UploadFile } from 'antd';
import {
  ERR_OCCURED_DOC_UPLOAD,
  ERR_UPLOAD_DOC_STATUS,
} from '@Src/commons/Constants';
import {
  TypeBillingEntity,
  TypeCompanyCreation,
  TypeCompanyDetails,
  TypeGetUserDocResponse,
  TypeServiceActivationData,
} from './OnboardingProps';

export const checkUniquPan = async (pan: string) => {
  const response: GenericResponseProp<string[]> = await checkUniquePanAPI(pan);
  if (response.error) throw new Error(response.error);
  if (response.data.length) return true;

  return false;
};

export const getCompanyDetailsFromGst = async (
  gstinNumber: string,
  userDetails?: boolean
) => {
  const response: GenericResponseProp<TypeCompanyDetails> =
    await getCompanyDetailsFromGstAPI(gstinNumber,userDetails);
  if (response.error) throw new Error(response.error);

  return response.data;
};

export const updateCompanyDetails = async (data: TypeCompanyCreation) => {
  const response: GenericResponseProp<object> = await updateCompanyDetailsAPI(
    data
  );
  if (response.error) throw new Error(response.error);
  return true;
};

export function validateIdentifier(
  identifierValue: string,
  pan: string
): string | undefined {
  if (identifierValue.length === 15) {
    if (
      !isValidGst(identifierValue) ||
      !isValidGSTForPAN(identifierValue, pan)
    ) {
      return 'Invalid GST';
    }
  } else {
    return 'Invalid ID';
  }

  return '';
}

export const getServiceActivationData = async () => {
  const response: GenericResponseProp<TypeServiceActivationData[]> =
    await getServiceActivationDataAPI();
  if (response.error) throw new Error(response.error);

  return response.data;
};

export const getVanDetails = async () => {
  const response: GenericResponseProp<TypeBillingEntity> =
    await getVanDetailsAPI();
  if (response.error) throw new Error(response.error);
  return response.data;
};

export const getUserDoc = async (serviceId: string) => {
  const response: GenericResponseProp<TypeGetUserDocResponse> =
    await getUserDocsAPI(serviceId);
  if (response.error) throw new Error(response.error);
  return response.data;
};
export const checkUploadStatus = async (duration = 0, token = '') => {
  await new Promise((r) => setTimeout(r, duration));
  const resp = await getFileUploadedDocumentStatusAPI(token);
  return resp;
};
export const removeFileActions = async (file: UploadFile) => {
  try {
    await ApiServices.removeFileActivationAPI(file.uid);
    return true;
  } catch (err) {
    return false;
  }
};

export const uploadingSubmittedDocument = async (
  data: string | Blob,
  uploadFile: {
    requestToken: string | undefined;
    name: string;
    uploadUrl: RequestInfo | URL;
  }
) => {
  try {
    const formData = new FormData();
    formData.append(
      'file',
      data,
      `${uploadFile.requestToken}_${uploadFile.name.toUpperCase()}`
    );
    const time1 = new Date().getTime();

    await fetch(uploadFile.uploadUrl, { method: 'PUT', body: formData });
    const time2 = new Date().getTime();
    const timeDiff = (time2 - time1) * 2;
    let resp;
    // wait for 5 sec to check the upload status
    resp = await checkUploadStatus(5000, uploadFile.requestToken);

    if (resp.fileUploadStatus === -1) {
      // Engagement is not done so throwing an error
      throw new Error(ERR_UPLOAD_DOC_STATUS);
    }
    if (resp.fileUploadStatus === 1) return resp;

    // wait for double the upload time.
    resp = await checkUploadStatus(timeDiff, uploadFile.requestToken);
    // uploaded successfully to hubsopt
    if (resp.fileUploadStatus === 1) return resp;

    // waiting for 5 sec more
    resp = await checkUploadStatus(5000, uploadFile.requestToken);
    // uploaded successfully to hubsopt
    if (resp.fileUploadStatus === 1) return resp;

    // waiting for final 10 sec
    resp = await checkUploadStatus(10000, uploadFile.requestToken);
    // uploaded successfully to hubsopt
    if (resp.fileUploadStatus === 1) return resp;

    throw new Error(ERR_OCCURED_DOC_UPLOAD); // Uploaded in progress so need to reload
  } catch (err: unknown) {
    throw err;
  }
};
